<div class="p-3 rounded-3">
  <div class="row mb-2">
    <div class="col-12 mb-3">
      <div class="titletoptables">
        <div class="leftsideicons">
          <img src="../../assets/image/multiple-users.png" alt="img" />
        </div>
        <h3>{{ "Client Details" }}</h3>
      </div>
    </div>

    <div class="row position">
      <div class="col-md-12 kt-margin-bottom-20-mobile" style="display:flex;">
        <div class="col-md-2">
          <div class="srchgrid texttarget">
            <input class="searchtextbox" matInput (keyup)="filterData($any($event.target).value)" [value]="searchString"
              placeholder="Search" autocomplete="off">
            <div class="closeicon" (keydown.enter)="clearList()" (click)="clearList()"> <span
                aria-hidden="true">&times;</span> </div>
          </div>
        </div>
        <div class="col-md-10 toogle">
          <div class="btn-group-offer">
            <mat-button-toggle-group *ngIf="isRadiologyDomain == false" class="toogleBtn" style="border-radius:10px"
              [value]="IsDoctor" (change)="onChange($event)">
              <mat-button-toggle [value]="false" *ngIf="IsTest==false">plusPhysio</mat-button-toggle>
              <mat-button-toggle [value]="false" *ngIf="IsTest==true">ifourConsultany.net</mat-button-toggle>
              <mat-button-toggle [value]="true" *ngIf="IsTest==false">plusDoctor</mat-button-toggle>
              <mat-button-toggle [value]="true" *ngIf="IsTest==true">localhost</mat-button-toggle>
            </mat-button-toggle-group>
            <button type="button" class="btn btn-primary toogleBtn" [disabled]="IsDisable"
              (click)="add(mailModal)">what's
              new</button>
            <button type="button" class="btn btn-primary toogleBtn" [disabled]="IsDisable"
              (click)="openAllMigrationDialog(null,AllmigrationDialog)">Add
              Migration</button>
            <button type="button" class="btn btn-primary toogleBtn" [disabled]="IsDisable"
              (click)="openMastermigrationDialog(null,MastermigrationDialog)">Add
              Master Migration</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="position">
    <kendo-grid #grid [loading]='kendoLoading' [data]="gridData" [filter]="state.filter" [sortable]="{mode: 'single'}"
      [columnMenu]="{ filter: true }" [pageSize]="state.take" [skip]="state.skip"
      [pageable]="gridData?.data?.length && gridData.data.length > 0 ? pageableWithAll : false"
      (pageChange)="pageChange($event)" [sort]="sort" (sortChange)="gridData ? sortChange($event): null"
      [resizable]="true" [reorderable]="true" filterable="menu" [filter]="state.filter" [selectable]="true"
      (dataStateChange)="gridData ? dataStateChange($event): null" [navigable]="true"
      (selectionChange)="checkboxChecked($event)" (columnVisibilityChange)="onColumnVisibilityChange(grid)"
      [height]="gridHeight">
      <kendo-grid-column title="Action" [width]="65" field='Id' [locked]="true" [sortable]="false" [filterable]="false"
        [columnMenu]="false" [resizable]="false" [reorderable]="false" [groupable]="false">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <button class="verical_menu" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown"
            aria-expanded="false">
            <img src="/assets/image/vertical-icon.png" alt="" class="vertical">
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li style="cursor: pointer;"><a class="dropdown-item"
                (click)="EditClientData(dataItem, EditDialog)">Edit</a></li>
            <li style="cursor:pointer ;"><a class="dropdown-item"
                (click)="openDelateDialog(dataItem, deleteDialog)">Delete</a></li>
            <li style="cursor:pointer ;"><a class="dropdown-item"
                (click)="openMigrationDialog(dataItem, migrationDialog)">Add Migration</a></li>
            <li style="cursor: pointer;"><a class="dropdown-item"
                (click)="openAddOnDialog(dataItem, addOnDialog)">Add-ons</a></li>
            <li style="cursor: pointer;"><a class="dropdown-item"
                (click)="openChangePlanDialog(dataItem, changePlanDialog)">Change Subscription</a></li>
            <li style="cursor: pointer;"><a class="dropdown-item"
                (click)="openWhatsappEnableDialog(dataItem, whatsappDialog)">Enable Whatsapp</a></li>
            <li style="cursor: pointer;"><a class="dropdown-item"
                (click)="openAIAssistantDialog(dataItem, aiAssistantDialog)">Enable AI Assistant</a></li>
            <li style="cursor: pointer;"><a class="dropdown-item" (click)="openResetPasswordDialog(dataItem)">Reset
                Password</a></li>
            <li style="cursor: pointer;"><a class="dropdown-item" (click)="openPlanLimitDialog(dataItem)">Plan Limits
              </a></li>
            <li *ngIf="dataItem.IsAutoRenew" style="cursor:pointer ;"><a class="dropdown-item"
                (click)="openCancelAutoRenewDialog(dataItem, autoRenewDialog)">Cancel Auto-Renew</a></li>
            <li style="cursor:pointer;"><a class="dropdown-item"
                (click)="openPlanHistoryDialog(dataItem, planHistoryDialog)">Plan history</a></li>
          </ul>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="FirstName" [locked]="true" [width]="150" title="Doctor Name">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.Salutation ?? '' }} {{ dataItem.FirstName }} {{ dataItem.LastName ?? '' }}
        </ng-template>
      </kendo-grid-column>
      <ng-container *ngIf="screenWidth >= 800">
        <kendo-grid-column field="CompanyName" [locked]="true" [width]="200" title="Clinic Name">
        </kendo-grid-column>
        <kendo-grid-column field="PhoneNumber" [width]="ClientColumnWidth" title="Phone Number">
        </kendo-grid-column>
        <kendo-grid-column field="AppointmentCount" [width]="ClientColumnWidth" title="Appointment Count">
        </kendo-grid-column>
        <kendo-grid-column field="PatientCount" [width]="ClientColumnWidth" title="Patient Count">
        </kendo-grid-column>
        <kendo-grid-column field="ActiveUser" [width]="ClientColumnWidth" title="Total Users">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.ActiveUser }} ({{ dataItem.InActiveUser }})
          </ng-template>
        </kendo-grid-column>
      </ng-container>
      <kendo-grid-column field="Domain" [width]="200" title="Domain">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <a class="domainclass" style="cursor: pointer; " class="dropdown-items"
            (click)="AdminLoginData(dataItem.Id,dataItem.Domain, 'DomainUrl')">{{dataItem.Domain}}</a>
        </ng-template>
      </kendo-grid-column>
      <ng-container *ngIf="screenWidth >= 1085">
        <kendo-grid-column field="Email" [width]="ClientColumnWidth" title="Email">
        </kendo-grid-column>
      </ng-container>

      <ng-container>
        <kendo-grid-column field="Status" title="Status" [width]="ClientColumnWidth" [class]="{ 'text-center': true }">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <span *ngIf="dataItem.Status">
              <kendo-dropdownlist [data]="dropdownValues" [textField]="'text'" [valueField]="'value'"
                [(ngModel)]="dataItem.Status" (selectionChange)="selectedOption($event, dataItem)"
                [ngStyle]="{ 'color': getStatusColor(dataItem.Status) }">
              </kendo-dropdownlist>
            </span>
          </ng-template>
        </kendo-grid-column>
      </ng-container>
      <kendo-grid-column field="IsActive" [width]="ClientColumnWidth" title="Active">
      </kendo-grid-column>
      <kendo-grid-column field="IsEmailVerified" [width]="ClientColumnWidth" title="Email-Verifiy">
      </kendo-grid-column>
      <kendo-grid-column field="CompanyAddress" [width]="ClientColumnWidth" title="Address">
      </kendo-grid-column>
      <kendo-grid-column field="IsTestAccount" [width]="ClientColumnWidth" title="TestAccount">
      </kendo-grid-column>
      <kendo-grid-column field="MigrationStatus" [width]="ClientColumnWidth" title="Status">
      </kendo-grid-column>
      <kendo-grid-column field="MigrationVersionInfo" [width]="ClientColumnWidth" title="Migration Version Info">
      </kendo-grid-column>
      <kendo-grid-column field="CreatedDate" [width]="ClientColumnWidth" title="Created Date">
      </kendo-grid-column>
      <kendo-grid-column field="IPAddress" [width]="ClientColumnWidth" title="IP Address">
      </kendo-grid-column>
      <kendo-grid-column field="IPLocation" [width]="ClientColumnWidth" title="IPLocation">
      </kendo-grid-column>
      <kendo-grid-column field="IsWhatsAppIntegration" [width]="ClientColumnWidth" title="WhatsApp Integration">
      </kendo-grid-column>
      <kendo-grid-column field="Country" [width]="ClientColumnWidth" title="Country">
      </kendo-grid-column>
      <kendo-grid-column field="Email" [width]="ClientColumnWidth" title="Email">
      </kendo-grid-column>
      <kendo-grid-column field="CompanyName" [width]="ClientColumnWidth" title="CompanyName">
      </kendo-grid-column>
      <kendo-grid-column field="SubscriptionPlanName" [width]="ClientColumnWidth" title="Subscription Plan">
      </kendo-grid-column>
      <kendo-grid-column field="PlanExpiryDate" [width]="ClientColumnWidth" title="Plan Expiry Date">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.PlanExpiryDate | date: 'dd/MM/YYYY' }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column [width]="250" field="AddOnDetails" title="Add-On">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div *ngFor="let detail of dataItem.AddOnDetails">
            {{ detail.AddOnCount }} - {{ detail.TypeName }} - {{ detail.AddOnDate | date: 'short' }}
          </div>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>
</div>
<ng-template #EditDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">User Managment</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeDialog()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="formValue" class="mt-3">
          <!-- Row: Salutation + Doctor Name -->
          <div class="row">
            <div class="col-3">
              <div class="form-group">
                <mat-form-field class="example-full-width custom-blue">
                  <mat-label>Salutation</mat-label>
                  <mat-select formControlName="Salutation" [panelClass]="'custom-select-panel'"
                    [disableOptionCentering]="true">
                    <mat-option value="Dr.">Dr.</mat-option>
                    <mat-option value="Mr.">Mr.</mat-option>
                    <mat-option value="Mrs.">Mrs.</mat-option>
                    <mat-option value="Ms.">Ms.</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-9">
              <div class="form-group">
                <mat-form-field class="example-full-width custom-blue">
                  <mat-label>Doctor Name</mat-label>
                  <input matInput formControlName="FirstName" maxlength="20" required />
                  <mat-error
                    *ngIf="formValue.controls['FirstName']?.touched && formValue.controls['FirstName']?.invalid">
                    This field is required.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <mat-form-field class="example-full-width custom-blue">
                  <mat-label>Clinic Name</mat-label>
                  <input matInput formControlName="CompanyName" />
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <mat-form-field class="example-full-width custom-blue">
                  <mat-label>Email</mat-label>
                  <input matInput type="email" formControlName="Email" placeholder="example@domain.com" maxlength="50"
                    (keyup)="handleBlurEmail($event)" required />
                  <mat-error *ngIf="formValue.controls['Email'].hasError('required')">This field is
                    required.</mat-error>
                  <mat-error *ngIf="formValue.controls['Email'].hasError('pattern')">Follow standard email
                    pattern.</mat-error>
                  <mat-error *ngIf="emailerror">Email already exists, please use a different email.</mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <mat-form-field class="example-full-width custom-blue">
                  <mat-label>Phone Number</mat-label>
                  <input matInput type="number" formControlName="PhoneNumber" (keypress)="keyPress($event)" required />
                  <mat-error
                    *ngIf="formValue.controls['PhoneNumber']?.touched && formValue.controls['PhoneNumber']?.invalid">
                    This field is required.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="form-group">
              <mat-form-field class="example-full-width custom-blue">
                <mat-label>Country</mat-label>
                <mat-select formControlName="CurrencyId" [panelClass]="'custom-select-panel'"
                  [disableOptionCentering]="true">
                  <mat-option *ngFor="let item of currencyList" [value]="item.Id">
                    {{ item.CountryName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="form-group">
              <mat-form-field class="example-full-width custom-blue">
                <mat-label>Clinic Address</mat-label>
                <input matInput formControlName="CompanyAddress" required />
                <mat-error
                  *ngIf="formValue.controls['CompanyAddress']?.touched && formValue.controls['CompanyAddress']?.invalid">
                  This field is required.
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <div class="form-group ">
                <label class="text-muted" style="font-size: 15px;" for="IsActive">Active</label>
                <div class="col-md-2 d-flex align-items-start btn-group" role="group"
                  aria-label="Basic radio toggle button group">
                  <input type="radio" class="btn-check" formControlName="IsActive" id="btnradio1" autocomplete="off"
                    value="true" (change)="onStatusChange(true)">
                  <label class="btn btn-outline-primary" for="btnradio1">ON</label>
                  <input type="radio" class="btn-check" formControlName="IsActive" id="btnradio2" autocomplete="off"
                    value="false" (change)="onStatusChange(false)">
                  <label class="btn btn-outline-primary" for="btnradio2">OFF</label>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label class="text-muted" style="font-size: 15px;" for="TestAccount">Test Account</label>
                <div class="col-md-2 d-flex align-items-start btn-group" role="group"
                  aria-label="Basic radio toggle button group">
                  <input type="radio" class="btn-check" formControlName="IsTestAccount" id="buttonradio1"
                    autocomplete="off" value="true">
                  <label class="btn btn-outline-primary" for="buttonradio1">ON</label>
                  <input type="radio" class="btn-check" formControlName="IsTestAccount" id="buttonradio2"
                    autocomplete="off" value="false">
                  <label class="btn btn-outline-primary" for="buttonradio2">OFF</label>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <mat-dialog-actions align="end">
        <button mat-raised-button style="margin-right: 10px;" type="button" class="btn btn-secondary"
          (click)="closeDialog()">Cancel</button>
        <button mat-raised-button type="button" class="btn btn-primary" (click)="updateAdmin()"
          [disabled]="isDisableUpdate">Update</button>
      </mat-dialog-actions>
    </div>
  </div>
</ng-template>
<ng-template #deleteDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="margin-bottom:5px">
        <h4 class="popup-title">Delete Confirmation</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeDialog()"></button>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <div>Are you sure you want to delete this Client?</div>
          <div>Also your <span style="font-weight: bold;">{{this.domain}}</span> domain will deleted.</div>
        </mat-dialog-content>
        <mat-dialog-actions align="end" style="gap:20px;">
          <button mat-raised-button (click)="closeDialog()" style="margin-left: 20px;" type="button"
            class="btn btn-secondary" data-bs-dismiss="modal" tabindex="-1">No</button>
          <button mat-raised-button type="button" (click)="DeleteClientData()" class="btn btn-primary"
            data-bs-toggle="modal" tabindex="-1">Yes</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #migrationDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="margin-bottom:5px">
        <h4 class="popup-title">Migration</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeDialog()"></button>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <div>Are you sure you want to Run Migration?</div>
        </mat-dialog-content>
        <mat-dialog-actions align="end" style="gap:20px;">
          <button mat-raised-button (click)="closeDialog()" style="margin-left: 20px;" type="button"
            class="btn btn-secondary" data-bs-dismiss="modal" tabindex="-1">No</button>
          <button mat-raised-button type="button" (click)="RunMigrationData()" class="btn btn-primary"
            data-bs-toggle="modal" tabindex="-1">Yes</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #AllmigrationDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="margin-bottom:5px">
        <h4 class="popup-title">Migration</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeDialog()"></button>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <div>Are you sure you want to Run All Migration?</div>

        </mat-dialog-content>
        <mat-dialog-actions align="end" style="gap:20px;">
          <button mat-raised-button (click)="closeDialog()" style="margin-left: 20px;" type="button"
            class="btn btn-secondary" data-bs-dismiss="modal" tabindex="-1">No</button>
          <button mat-raised-button type="button" (click)="addMigration()" class="btn btn-primary"
            data-bs-toggle="modal" tabindex="0">Yes</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #mailModal>
  <div class="modal-header mb-2 mail-model-header"
    style="margin-bottom:5px; display: flex; align-items: center; justify-content: space-between;">
    <h4 class="popup-title">
      Email For New Features
    </h4>
    <div class="addclosebtn">
      <button style="align-items: center; display: flex; padding: 2px 10px 2px 10px;" type="button"
        class="btn btn-primary addTemplateBtn" (click)="addTemplate(newmodel)">Add Template</button>
      <div class="header-actions" style="display: flex; gap: 8px;">
        <button mat-icon-button (click)="toggleMaximize()">
          <mat-icon style="margin-top:-22px;">{{ isMaximized ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
        </button>
        <button type="button" style="margin-top:15px;" class="btn-close" aria-label="Close"
          (click)="closeDialog()"></button>
      </div>
    </div>
  </div>
  <div class="mat-dialog-content">
    <div class="row" style="border-bottom: 1px solid #80808075 !important;">
      <div class="col-12 col-md-12">
        <mat-form-field class="saveInput lablessfonts mat-form-field-fluid">
          <input type="text" matInput placeholder="Subject" [(ngModel)]="subject" maxlength="100" required />
          <mat-error *ngIf="subject==''">
            <span class="error">Subject is required</span>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-12 col-md-12 mt-0 mb-3">
        <kendo-floatinglabel text="Select Client(s)"
          style="width: 100%; font-size: inherit;font-weight: 400;font-family: 'Poppins', sans-serif;letter-spacing: normal; color: #7c7c7c;">
          <kendo-multiselect id="test" [kendoDropDownFilter]="filterSettings" [placeholder]="'Select Client'"
            [autoClose]="false" [(ngModel)]="value" class="searchBox" (valueChange)="valueChange($event)"
            [data]="allAdminData" textField="FirstName" valueField="Id" (keyup)="filterFunction($event)">
            <ng-template kendoMultiSelectHeaderTemplate>
              <span *ngIf="!isShow" style="margin-left:8px">
                <kendo-label for="chk">{{ toggleAllText }}</kendo-label>
                <input style="margin-left:4px" type="checkbox" id="chk" [checked]="isChecked" (click)="onClick()" />
              </span>
            </ng-template>
          </kendo-multiselect>
        </kendo-floatinglabel>
      </div>

      <div class="col-12 col-md-12 mt-0 mb-3">
        <kendo-floatinglabel text="Templates" class="drp-template">

          <!-- Single Select Dropdown -->
          <kendo-dropdownlist [data]="templateData" [(ngModel)]="selectedTemplate" textField="Name" valueField="Id"
            (valueChange)="onTemplateChange($event)">
          </kendo-dropdownlist>

        </kendo-floatinglabel>
      </div>

      <div class="col-12 col-md-12">
        <label for="templatebody"
          style="font-size: inherit;font-weight: 400;font-family: 'Poppins', sans-serif;letter-spacing: normal;"
          [ngClass]="{'required': !isInputFieldEmpty}">Template
          Body<span> *</span></label>
        <kendo-editor id="templatebody" #editor matInput [(ngModel)]="templateBody" placeholder="Template Body"
          style="height: 250px;" (valueChange)="onInputChange()" required>
          <kendo-toolbar>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>

            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>

            <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
            <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
            <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
            <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
            <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
            <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient"></kendo-toolbar-colorpicker>
          </kendo-toolbar>
        </kendo-editor>
        <mat-error *ngIf='!isInputFieldEmpty'>
          <span class="error">Template Body is required</span>
        </mat-error>
      </div>
      <div class="col-12 col-md-12 mt-3">
        <label class="keyWordlbl">KeyWord</label>
      </div>
      <div class="col-12 col-md-12 mt-2" *ngFor="let key of keyWordList">
        <div class="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base" aria-hidden="false">
          <span class="k-chip-content">
            <span style="padding-bottom: 2px;" class="k-chip-label k-text-ellipsis"
              (click)="insertTextAtCursor(key.id)">{{key.id}}</span>
          </span>
        </div><span>&nbsp;:{{key.text}}</span>
      </div>
    </div>
  </div>

  <div class="row" style="float: right;">
    <div class="col-lg-12">
      <button type="submit" id="kt_login_signin_submit" class="btn btn-primary btn-elevate m-2 float-right"
        (click)="submit(createMailForm)">
        Submit
      </button>
      <button mat-dialog-close class="btn btn-secondary btn-elevate float-right">
        Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #mailCountModal>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="margin-bottom:5px">
        <h4 class="popup-title">
          {{ IsReleaseNote ? 'Release Detail' : 'Mail details' }}
        </h4>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <div *ngIf="!IsReleaseNote">
            <div>Your <b>{{TotalSendEmails}}</b> email request has been successfully processed.&nbsp;
              <span *ngIf="TotalUnSendEmails != 0">But we were unable to send <b>{{TotalUnSendEmails}}</b> emails due to
                the
                inability to send an email.</span>
            </div>
            <div *ngIf="CompantData.length > 0">
              <kendo-grid [loading]='kendoLoading' [data]="CompantData" [resizable]="true" [reorderable]="true">
                <kendo-grid-column field="FirstName" title="Clinic Name">
                </kendo-grid-column>
                <kendo-grid-column field="Domain" title="Domain">
                </kendo-grid-column>
                <kendo-grid-column field="Email" title="Email">
                </kendo-grid-column>
                <kendo-grid-column field="IsActive" title="Active">
                  <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <span *ngIf="dataItem.IsActive">Yes</span>
                    <span *ngIf="!dataItem.IsActive">No</span>
                  </ng-template>
                </kendo-grid-column>
              </kendo-grid>
            </div>
          </div>
          <div *ngIf="IsReleaseNote">
            Release Note Sent SuccessFully.
          </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end" style="gap:20px;">
          <button mat-raised-button (click)="closeDialog()" style="margin-left: 20px;" type="button"
            class="btn btn-secondary" data-bs-dismiss="modal" tabindex="-1">Ok</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #newmodel>
  <div class="modal-header mb-2 mail-model-header">
    <h4 class="popup-title">
      Email Template
    </h4>
    <div class="addclosebtn">
      <div class="header-actions">
        <button mat-icon-button (click)="toggleMaximize1()">
          <mat-icon style="margin-bottom:15px;">{{ isMaximizedEmail ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()"></button>
      </div>
    </div>
  </div>
  <div class="mat-dialog-content matwidth">
    <div class="row mb-3" style="border-bottom: 1px solid #80808075 !important;">
      <div class="col-12 col-md-12 mb-2">
        <mat-form-field class=" nameInput lablessfonts mat-form-field-fluid">
          <input type="text" matInput placeholder="Template Name" [(ngModel)]="Name" maxlength="100" required />
          <mat-error *ngIf="Name==''">
            <span class="error">Template Name is required</span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-12" style="margin-bottom: 10px;">
        <label for="templatebody2"
          style="font-size: inherit;font-weight: 400;font-family: 'Poppins', sans-serif;letter-spacing: normal;"
          [ngClass]="{'required': !isTemplateInputFieldEmpty}">Template
          Body<span> *</span></label>
        <kendo-editor id="templatebody2" matInput [(ngModel)]="Body" placeholder="Template Body" style="height: 250px;"
          (valueChange)="InputChange()" required>
          <kendo-toolbar>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
            <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
            <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
            <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
            <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
            <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient"></kendo-toolbar-colorpicker>
          </kendo-toolbar>
        </kendo-editor>
        <mat-error *ngIf='!isTemplateInputFieldEmpty'>
          <span class="error">Template Body is required</span>
        </mat-error>
      </div>
    </div>

    <div class="row" style="float: right;">
      <div class="col-lg-12">
        <button type="submit" id="kt_login_signin_submit" class="btn btn-primary btn-elevate m-2 float-right"
          (click)="save(addMailForm)">
          Submit
        </button>
        <button mat-dialog-close class="btn btn-secondary btn-elevate float-right">
          Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #addOnDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="margin-bottom:5px">
        <h4 class="popup-title">Manage Add-ons</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeDialog()"></button>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <div class="container-fluid">
            <!-- Header Row -->
            <div class="row mb-3 pb-2 border-bottom">
              <div class="col-2 font-weight-bold text-muted">
                Add-on
              </div>
              <div class="col-2 font-weight-bold text-muted text-end">
                Existing
              </div>
              <div class="col-5 font-weight-bold text-muted text-center">
                quantity
              </div>
              <div class="col-3 font-weight-bold text-muted text-end">
                Price/Unit
              </div>
            </div>

            <!-- Add-on Items -->
            <div class="row mb-2" *ngFor="let item of addOns">
              <div class="col-2 font-weight-bold mt-1">
                {{ item.name == 'Storage' ? 'Storage (GB)' : item.name }}
              </div>
              <div class="col-2 d-flex flex-column align-items-end mt-1">
                {{ item.previousQuantity }}
              </div>
              <div class="col-5">
                <div class="input-group input-group-sm">
                  <button class="btn btn-outline-secondary" type="button" (click)="decrement(item)">-</button>
                  <input type="number" class="form-control text-center" [(ngModel)]="item.quantity" min="0"
                    (keypress)="onlyPositiveNumbers($event)"
                    [readOnly]="item.name === 'Patients' || item.name === 'Storage'" />
                  <button class="btn btn-outline-secondary" type="button" (click)="increment(item)">+</button>
                </div>
              </div>
              <div class="col-3 d-flex flex-column align-items-end">
                <input type="number" class="form-control form-control-sm text-end mb-1" [(ngModel)]="item.price" min="0"
                  (focusout)="setItemPrice($event, item)" />
                <small class="text-muted">
                  ₹ {{ item.id == 3 ? (item.quantity/1000 * item.price) : (item.id == 4 ? item.quantity/100 * item.price
                  : item.quantity * item.price) }}
                </small>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-10 text-end font-weight-bold">
                Total:
              </div>
              <div class="col-2 text-end font-weight-bold">
                ₹ {{ getAddOnTotal() }}
              </div>
            </div>
          </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
          <button mat-raised-button (click)="closeDialog()" style="margin-right: 10px;" type="button"
            class="btn btn-secondary" data-bs-dismiss="modal" tabindex="-1">Cancel</button>
          <button mat-raised-button type="button" (click)="submitAddOn()" class="btn btn-primary" data-bs-toggle="modal"
            tabindex="-1">Save</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #changePlanDialog>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header plan-header">
        <h4 class="popup-title mb-0">Change Subscription</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()"></button>
      </div>

      <div class="toggle-container d-flex justify-content-md-end">
        <span class="toggle-text">Monthly</span>
        <mat-slide-toggle class="custom-toggle" [(ngModel)]="isPlanYearly"
          (change)="onPlanToggle($event)"></mat-slide-toggle>
        <span class="toggle-text">Yearly</span>
        <mat-form-field class="currency-dropdown" appearance="outline">
          <mat-select [(ngModel)]="selectedCurrencyId" (selectionChange)="onCurrencyChange($event)"
            placeholder="Currency" [panelClass]="'custom-select-panel-outline'" [disableOptionCentering]="true">
            <mat-option *ngFor="let currency of currencyMap" [value]="currency.Id">
              {{ currency.CurrencyCode }} ({{ currency.CurrencySymbol }})
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="modal-body pt-0">
        <mat-dialog-content>
          <div class="container-fluid">
            <div class="row py-2 border-bottom align-items-center"
              [ngClass]="{ 'current-plan-row': item.id === selectedPlanId }" *ngFor="let item of plans; let i = index">
              <div class="col-12 col-md-3 fw-semibold text-dark">
                {{ item.name }}
              </div>
              <!-- Price -->
              <div class="col-12 col-md-4 fw-semibold text-dark d-flex align-items-center px-0">
                <ng-container *ngIf="item.id == 5; else paidPlan">
                  Free
                </ng-container>
                <ng-template #paidPlan>
                  {{ getCurrencySymbolById(selectedCurrencyId) }}&nbsp;
                  <input type="number" placeholder="Enter amount"
                    [value]="(item.id == 6 || item.id == 7) ? (isPlanYearly ? item.annualPrice : item.monthlyPrice) : ''"
                    class="form-control d-inline-block ms-1 enterprise-input w-50"
                    (change)="updatePlanPrice(i, $event)" />
                  <span class="addOnLabel ms-2" *ngIf="item.isShowAddOn">(Inc. Add-ons)</span>
                </ng-template>
              </div>
              <div class="col-12 col-md-3 fw-semibold text-dark d-flex align-items-center">
                <mat-form-field class="w-100" *ngIf="item.id > selectedPlanId && item.id != 5">
                  <input matInput [matDatepicker]="picker1" placeholder="Expiry Date" readonly [min]="today"
                    (dateChange)="onExpiryDateChange(i, $event)" [value]="expiryDate" />
                  <mat-datepicker-toggle matSuffix [for]="picker1">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2 text-md-end">
                <button class="plan-action-label my-2" [ngClass]="{
                          'degrade': item.id < selectedPlanId,
                          'renew': item.id == selectedPlanId,
                          'upgrade': item.id > selectedPlanId
                        }" (click)="changePlan(item)" (keydown.enter)="changePlan(item)">
                  {{ item.id < selectedPlanId ? 'Degrade' : (item.id==selectedPlanId ? 'Renew' : 'Upgrade' ) }}
                    </button>
              </div>
            </div>
          </div>
        </mat-dialog-content>
      </div>

      <div class="toggle-container d-flex">
        <span class="toggle-text">Attach invoice when sending the plan change email</span>
        <mat-slide-toggle class="custom-toggle" [(ngModel)]="isSendInvoice"></mat-slide-toggle>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #changePLanConfirmationDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="margin-bottom:5px">
        <h4 class="popup-title">Change Subscription</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeConfirmationDialog()"></button>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <div *ngIf="selectedRecord.SubscriptionPlanId != newPlan.id">Are you sure you want to switch from the
            {{selectedRecord.SubscriptionPlanName}} to the {{newPlan.name}}?</div>
          <div *ngIf="selectedRecord.SubscriptionPlanId == newPlan.id">Are you sure you want to renew
            {{selectedRecord.SubscriptionPlanName}}?</div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
          <button mat-raised-button (click)="closeConfirmationDialog()" style="margin-right: 10px;" type="button"
            class="btn btn-secondary" tabindex="-1">No</button>
          <button mat-raised-button type="button" (click)="updatePlan()" class="btn btn-primary">Yes</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #MastermigrationDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="margin-bottom:5px">
        <h4 class="popup-title">Migration</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeDialog()"></button>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <div>Are you sure you want to Run Master Migration?</div>

        </mat-dialog-content>
        <mat-dialog-actions align="end" style="gap:20px;">
          <button mat-raised-button (click)="closeDialog()" style="margin-left: 20px;" type="button"
            class="btn btn-secondary" data-bs-dismiss="modal" tabindex="-1">No</button>
          <button mat-raised-button type="button" (click)="addMasterMigration()" class="btn btn-primary"
            data-bs-toggle="modal" tabindex="-1">Yes</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #whatsappDialog>
  <div class="modal-header mb-2">
    <h4 class="popup-title">Enable Whatsapp</h4>
    <button type="button" class="btn-close" mat-dialog-close data-bs-dismiss="modal" aria-label="Close"></button>
  </div>

  <div class="mat-dialog-content">
    <form [formGroup]="whatsappForm">
      <div class="mb-3">
        <mat-radio-group formControlName="Provider">
          <mat-radio-button value="Ifour" class="me-3">IFour (Free)</mat-radio-button>
          <mat-radio-button value="SmsIdea">Sms Idea (Paid)</mat-radio-button>
        </mat-radio-group>
      </div>

      <mat-form-field class="w-100 mb-3 custom-blue" *ngIf="whatsappForm.get('Provider')?.value === 'SmsIdea'">
        <mat-label>Instance Key</mat-label>
        <input matInput formControlName="InstanceKey" placeholder="Enter Instance Key" required />
        <mat-error
          *ngIf="(whatsappForm.get('InstanceKey')?.touched || isWhatsappSubmitted) && whatsappForm.get('InstanceKey')?.invalid">
          This field is required.
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100 mb-3 custom-blue">
        <mat-label>Expiry Date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="ExpiryDate" [min]="today" placeholder="Expiry date"
          required readonly (click)="picker.open()">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error
          *ngIf="(whatsappForm.get('ExpiryDate')?.touched || isWhatsappSubmitted) && whatsappForm.get('ExpiryDate')?.invalid">
          Please select an expiry date.
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100 mb-3 custom-blue">
        <mat-label>Amount</mat-label>
        <input matInput type="number" formControlName="Amount" placeholder="Enter Amount" required />
        <mat-error
          *ngIf="(whatsappForm.get('Amount')?.touched || isWhatsappSubmitted) && whatsappForm.get('Amount')?.invalid">
          Please enter a valid amount.
        </mat-error>
      </mat-form-field>

      <div class="mb-3">
        <label for="locationtypes" class="text-muted" style="font-size: 15px;">Location Type</label>
        <mat-radio-group formControlName="IsGloble" class="d-flex">
          <mat-radio-button [value]="true" class="me-3">Global</mat-radio-button>
          <mat-radio-button [value]="false">Location-wise</mat-radio-button>
        </mat-radio-group>
      </div>

      <mat-form-field class="w-100 mb-3 custom-blue" *ngIf="whatsappForm.get('IsGloble')?.value === false">
        <mat-label>Location</mat-label>
        <mat-select formControlName="LocationId" [panelClass]="'custom-select-panel'" [disableOptionCentering]="true"
          required>
          <mat-option *ngFor="let item of locationList" [value]="item.Id">
            {{ item.Name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="whatsappForm.get('LocationId')?.touched && whatsappForm.get('LocationId')?.invalid">
          Please select a location.
        </mat-error>
      </mat-form-field>
    </form>

    <div class="row" style="float: right;">
      <div class="col-lg-12">
        <button mat-dialog-close class="btn btn-secondary btn-elevate m-2 float-right">
          Cancel
        </button>
        <button type="button" id="kt_login_signin_submit" class="btn btn-primary btn-elevate float-right"
          (click)="addWhatsappInstance()">
          Submit
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #changeResetPasswordDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="margin-bottom:5px">
        <h4 class="popup-title">Reset Password</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeDialog()"></button>
      </div>
      <div class="modal-body">
        <form class="kt-form" [formGroup]="form" autocomplete="off">
          <div class="form-group">
            <mat-form-field class="example-full-width saveInput">
              <mat-label>New Password</mat-label>
              <input matInput [type]="hideNewPassword ? 'password' : 'text'" formControlName="NewPassword"
                autocomplete="off" minlength="6" required />
              <mat-icon matSuffix (click)="toggleNewPasswordVisibility()" (keydown)="onIconKeyDown($event)"
                style="cursor: pointer;">
                {{ hideNewPassword ? 'visibility_off' : 'visibility' }}
              </mat-icon>
              <mat-error *ngIf="isControlHasError('NewPassword','required')">
                This field is required
              </mat-error>
              <mat-error *ngIf="isControlHasError('NewPassword','minlength')">
                Password must be atleast 6 characters
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-group">
            <mat-form-field class="example-full-width saveInput">
              <mat-label>Confirm Password</mat-label>
              <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="ConfirmPassword"
                autocomplete="off" minlength="6" required />
              <mat-icon matSuffix (click)="toggleConfirmPasswordVisibility()" (keydown)="onIconKeyDownConfirm($event)"
                style="cursor: pointer;">
                {{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}
              </mat-icon>

              <mat-error *ngIf="isControlHasError('ConfirmPassword','required')">
                This field is required
              </mat-error>
              <mat-error *ngIf="isControlHasError('ConfirmPassword','minlength')">
                Password must be atleast 6 characters
              </mat-error>
              <mat-error *ngIf="form.get('ConfirmPassword')?.hasError('matching')">
                Passwords do not match
              </mat-error>

            </mat-form-field>
          </div>

          <div class="row">
            <div class="col-lg-12 kt-margin-bottom-20-mobile ">
              <button style="float: right;" (click)="submitResetForm()" id="kt_login_signin_submit"
                [class.spinner]="loading" [disabled]="loading"
                class="btn btn-primary  btn-elevate kt-login__btn-primary  ml-2 float-right">Save</button>
              <button style=" float: right; margin-right: 11px;" (click)="close()" type="button"
                class="btn btn-secondary btn-elevate kt-login__btn-secondary float-right ml-3">Cancel</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #planLimitDialog>
  <div class="d-flex justify-content-between">
    <h4 class="dialog-title">Plan Limit</h4>
    <div class="dialog-controls">
      <button type="button" class="btn-close" aria-label="Close" mat-dialog-close></button>
    </div>
  </div>
  <div class="pt-3">
    <form class="kt-form" [formGroup]="planLimitForm" autocomplete="off">
      <div class="form-group">
        <mat-form-field class="example-full-width custom-blue">
          <mat-label>Service Item</mat-label>
          <input matInput type="number" formControlName="ServiceItem" autocomplete="off" required />
          <mat-error *ngIf=" (planLimitForm.controls['ServiceItem'].hasError('required') &&  planLimitForm.controls['ServiceItem'].touched) ||
                                            planLimitForm.controls['ServiceItem'].untouched">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-group">
        <mat-form-field class="example-full-width custom-blue">
          <mat-label>Patient Custom Field</mat-label>
          <input matInput type="number" formControlName="PatientCustomField" autocomplete="off" required />
          <mat-error *ngIf=" (planLimitForm.controls['PatientCustomField'].hasError('required') &&  planLimitForm.controls['PatientCustomField'].touched) ||
                                            planLimitForm.controls['PatientCustomField'].untouched">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-group">
        <mat-form-field class="example-full-width custom-blue">
          <mat-label>Reference</mat-label>
          <input matInput type="number" formControlName="Reference" autocomplete="off" required />
          <mat-error *ngIf=" (planLimitForm.controls['Reference'].hasError('required') &&  planLimitForm.controls['Reference'].touched) ||
                                            planLimitForm.controls['Reference'].untouched">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <div class="col-lg-12 kt-margin-bottom-20-mobile ">
          <button style="float: right;" (click)="updatePlanLimit()" id="kt_login_signin_submit"
            [class.spinner]="loading" [disabled]="loading"
            class="btn btn-primary  btn-elevate kt-login__btn-primary  ml-2 float-right">Update</button>
          <button style=" float: right; margin-right: 11px;" (click)="close()" type="button"
            class="btn btn-secondary btn-elevate kt-login__btn-secondary float-right ml-3">Cancel</button>
        </div>
      </div>
    </form>
  </div>
</ng-template>
<ng-template #autoRenewDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="margin-bottom:5px">
        <h4 class="popup-title">Cancel Confirmation</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeDialog()"></button>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <div>Are you sure you want to disable Auto-Renew?</div>
        </mat-dialog-content>
        <mat-dialog-actions align="end" style="gap:20px;">
          <button mat-raised-button (click)="closeDialog()" style="margin-left: 20px;" type="button"
            class="btn btn-secondary" data-bs-dismiss="modal" tabindex="-2">No</button>
          <button mat-raised-button type="button" (click)="cancelAutoRenew()" class="btn btn-primary"
            data-bs-toggle="modal" tabindex="-1">Yes</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #planHistoryDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header mb-2">
        <h4 class="popup-title">Plan History</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeDialog()"></button>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <div class="account-tabs mb-4">
            <div class="tab-pills">
              <button type="button" class="tab-item" [class.active]="activeTab === 0" (click)="activeTab = 0">
                Subscription Plan
              </button>
              <button type="button" class="tab-item" [class.active]="activeTab === 1" (click)="activeTab = 1">
                WhatsApp Plan
              </button>
            </div>
          </div>

          <!-- SUBSCRIPTION PLAN TAB -->
          <div class="timeline-container" *ngIf="activeTab === 0">
            <!-- CURRENT PLAN -->
            <div class="timeline-item active-timeline-item">
              <div class="timeline-dot currentplan">
                <img src="../../assets/image/backlog-history.png" alt="Current" class="timeline-logo" />
              </div>

              <div class="timeline-content">
                <h4 class="plan-status status-activated mb-2">Active Plan</h4>
                <div class="plan-card active-plan-card p-0">
                  <div class="plan-left-content p-4" *ngIf="currentPlan">
                    <div class="plan-header mb-4 d-flex justify-content-between align-items-center">
                      <div class="meta-item">
                        <span class="meta-label">Plan Name</span>
                        <h3 class="plan-name mb-0">{{ currentPlan?.PlanName || 'Subscription Plan' }}</h3>
                      </div>
                      <div class="plan-remaining" *ngIf="currentPlan?.daysRemaining">
                        <img src="../../assets/image/clock.png" class="hourglass-icon" alt="Remaining" />
                        {{ currentPlan.daysRemaining }} days remaining
                      </div>
                    </div>
                    <div class="plan-meta-grid">
                      <div class="meta-item">
                        <span class="meta-label">Activated on</span>
                        <span class="meta-value">{{ currentPlan.Date | date:'dd MMM yyyy, hh:mm a' }}</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-label">Expiry Date</span>
                        <span class="meta-value">{{ currentPlan.TransactionExpiryDate | date:'dd MMM yyyy' }}</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-label">Payment Status</span>
                        <span class="meta-value">
                          <span class="status-pill" [ngClass]="currentPlan.TransactionStatus ? 'paid' : 'unpaid'"
                            *ngIf="currentPlan.SubscriptionPlanId != 5">
                            {{ currentPlan.TransactionStatus ? 'Paid' : 'Unpaid' }}
                          </span>
                          <span class="status-pill na" *ngIf="currentPlan.SubscriptionPlanId == 5">-</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="p-4" *ngIf="!currentPlan">
                    <div class="d-flex justify-content-between align-items-center">
                      <h3 class="plan-name mb-0">No Active Plan</h3>
                    </div>
                  </div>
                  <!-- Bottom Add-ons section -->
                  <div class="plan-right-content border-top p-3" *ngIf="currentPlan?.addOns?.length > 0">
                    <div class="d-flex align-items-center p-2">
                      <h5 class="section-title mb-0 me-4">Add-On</h5>
                      <div class="addon-list">
                        <div class="addon-row" *ngFor="let addon of currentPlan.addOns">
                          <span class="addon-name">{{ addon.TypeName }}</span>
                          <span class="addon-count-badge">{{ addon.AddOnCount }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- PREVIOUS PLANS -->
            <div class="timeline-item" *ngFor="let plan of previousPlan">
              <div class="timeline-dot previousplan">
                <img src="../../assets/image/backlog-history.png" alt="Logo" class="timeline-logo" />
              </div>

              <div class="timeline-content">
                <h4 class="plan-status status-expired mb-2">Expired Plan</h4>
                <div class="plan-card expired-plan-card p-0">
                  <div class="plan-left-content p-4">
                    <div class="plan-header mb-4">
                      <div class="meta-item">
                        <span class="meta-label">Plan Name</span>
                        <h3 class="plan-name mb-0">{{ plan.PlanName || '-' }}</h3>
                      </div>
                    </div>

                    <div class="plan-meta-grid">
                      <div class="meta-item">
                        <span class="meta-label">Activated on</span>
                        <span class="meta-value">{{ plan.Date | date:'dd MMM yyyy, hh:mm a' }}</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-label">Expired Date</span>
                        <span class="meta-value">{{ plan.TransactionExpiryDate | date:'dd MMM yyyy' }}</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-label">Payment Status</span>
                        <span class="meta-value">
                          <span class="status-pill" [ngClass]="plan.TransactionStatus ? 'paid' : 'unpaid'"
                            *ngIf="plan.SubscriptionPlanId != 5">
                            {{ plan.TransactionStatus ? 'Paid' : 'Unpaid' }}
                          </span>
                          <span class="status-pill na" *ngIf="plan.SubscriptionPlanId == 5">-</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Bottom Add-ons section -->
                  <div class="plan-right-content border-top p-3" *ngIf="plan.addOns?.length > 0">
                    <div class="d-flex align-items-center p-2">
                      <h5 class="section-title mb-0 me-4">Add-On</h5>
                      <div class="addon-list">
                        <div class="addon-row" *ngFor="let addon of plan.addOns">
                          <span class="addon-name">{{ addon.TypeName }}</span>
                          <span class="addon-count-badge">{{ addon.AddOnCount }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- WHATSAPP PLAN TAB -->
          <div class="timeline-container" *ngIf="activeTab === 1">
            <!-- CURRENT WHATSAPP PLAN -->
            <div class="timeline-item active-timeline-item">
              <div class="timeline-dot currentplan">
                <img src="../../assets/image/backlog-history.png" alt="Current" class="timeline-logo" />
              </div>

              <div class="timeline-content">
                <h4 class="plan-status status-activated mb-2">Active Plan</h4>
                <div class="plan-card active-plan-card p-0">
                  <div class="plan-left-content p-4" *ngIf="currentWhatsAppPlan">
                    <div class="plan-header mb-4 d-flex justify-content-between align-items-center">
                      <h3 class="plan-name mb-0">WhatsApp Subscription</h3>
                      <span class="plan-remaining" *ngIf="currentWhatsAppPlan?.daysRemaining">
                        <img src="../../assets/image/clock.png" class="hourglass-icon" alt="Remaining" />
                        {{ currentWhatsAppPlan.daysRemaining }} days remaining
                      </span>
                    </div>
                    <div class="plan-meta-grid">
                      <div class="meta-item">
                        <span class="meta-label">Activated on</span>
                        <span class="meta-value">{{ currentWhatsAppPlan.Date | date:'dd MMM yyyy, hh:mm a' }}</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-label">Expiry Date</span>
                        <span class="meta-value">{{ currentWhatsAppPlan.TransactionExpiryDate | date:'dd MMM
                          yyyy'}}</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-label">Payment Status</span>
                        <span class="meta-value">
                          <span class="status-pill"
                            [ngClass]="currentWhatsAppPlan.TransactionStatus ? 'paid' : 'unpaid'">
                            {{ currentWhatsAppPlan.TransactionStatus ? 'Paid' : 'Unpaid' }}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="p-4" *ngIf="!currentWhatsAppPlan">
                    <div class="d-flex justify-content-between align-items-center">
                      <h3 class="plan-name mb-0">No Active WhatsApp Plan</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- PREVIOUS WHATSAPP PLANS -->
            <div class="timeline-item" *ngFor="let plan of previousWhatsAppPlan">
              <div class="timeline-dot previousplan">
                <img src="../../assets/image/backlog-history.png" alt="Logo" class="timeline-logo" />
              </div>

              <div class="timeline-content">
                <h4 class="plan-status status-expired mb-2">Expired Plan</h4>
                <div class="plan-card expired-plan-card p-0">
                  <div class="plan-left-content p-4">
                    <div class="plan-meta-grid">
                      <div class="meta-item">
                        <span class="meta-label">Activated on</span>
                        <span class="meta-value">{{ plan.Date | date:'dd MMM yyyy, hh:mm a' }}</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-label">Expired Date</span>
                        <span class="meta-value">{{ plan.TransactionExpiryDate | date:'dd MMM yyyy' }}</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-label">Payment Status</span>
                        <span class="meta-value">
                          <span class="status-pill" [ngClass]="plan.TransactionStatus ? 'paid' : 'unpaid'">
                            {{ plan.TransactionStatus ? 'Paid' : 'Unpaid' }}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-dialog-content>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #aiAssistantDialog>
  <div class="modal-header">
    <h4 class="popup-title">Enable AI Assistant</h4>
    <button type="button" class="btn-close" mat-dialog-close data-bs-dismiss="modal" aria-label="Close"></button>
  </div>

  <div class="mat-dialog-content ai-dialog-content">
    <div class="d-flex align-items-center justify-content-between mb-2 mt-2">
      <span class="text-muted">
        Allows users to access the AI Assistant
      </span>
      <mat-slide-toggle class="custom-toggle" [(ngModel)]="isAiEnabled">
        {{ isAiEnabled ? 'ON' : 'OFF' }}
      </mat-slide-toggle>
    </div>

    <div class="mat-dialog-actions pb-2 justify-content-end">
      <button mat-dialog-close class="btn btn-secondary m-1">
        Close
      </button>
      <button type="button" class="btn btn-primary m-1" (click)="updateAIAssistantStatus()">
        Update
      </button>
    </div>
  </div>
</ng-template>